import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {initializeDefaultStates, getAccessToken, initializeUserStates} from '../actions';
import { checkUserLoggedIn } from './../utils';
import LoadingMessage from './../components/LoadingMessage';
import IntroMessage from './IntroMessage';
import _ from 'lodash';

class HomePage extends Component {

  componentDidMount() {
    this.props.initializeDefaultStates();

    const {location, user, getAccessToken} = this.props;
    const {oauth_verifier, oauth_token} = location.query;

    if (oauth_verifier && (oauth_token === user.oauthToken)) {
      getAccessToken(oauth_verifier, () => {
        if (this.props.isUserLoggedIn) {
          this.props.initializeUserStates();
        }
      });
    }
  }

  render() {
    const {parkingSpotsList} = this.props;

    return (
      <div className="map-page map-page__message">
        {_.isEmpty(parkingSpotsList) ? < LoadingMessage /> : <IntroMessage />}
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    parkingSpotsList: state.parkingSpots.list,
    user: state.user,
    isUserLoggedIn: checkUserLoggedIn(state.user),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ initializeDefaultStates, initializeUserStates, getAccessToken }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/containers/HomePage.js